import React from 'react';
const points = [{
  num: '01',
  title: 'Domingo por la tarde = Ansiedad.',
  desc: 'Sacrificas el descanso buscando qué drills dar el lunes para no repetir siempre lo mismo.'
}, {
  num: '02',
  title: 'El trabajo no termina nunca.',
  desc: 'Después de horas de clase, llegas a casa con la carga mental de preparar el entrenamiento de la mañana.'
}, {
  num: '03',
  title: 'Jugadores que "se estancan".',
  desc: 'Sientes que te faltan herramientas para que vean resultados reales en su técnica y fluidez de juego.'
}, {
  num: '04',
  title: 'Buscas reconocimiento.',
  desc: 'Quieres ser el entrenador que presenta un programa riguroso, moderno y de excelencia en su club.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-137">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <span className="inline-block text-primary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-141">
            👀 ¿Reconoces estas escenas?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-142">
            Megapack Handball Listo es para ti{' '}
            <span className="text-primary" data-id="element-143">si vives esto:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-144">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-all group shadow-lg hover:-translate-y-1" data-id="element-145">
              <div className="text-primary/30 group-hover:text-primary font-black text-3xl sm:text-4xl flex-shrink-0 transition-colors tracking-tighter" data-id="element-146">
                {point.num}
              </div>
              <div className="flex-1" data-id="element-147">
                <h3 className="text-text-main text-lg sm:text-xl font-bold leading-snug mb-2" data-id="element-148">
                  {point.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-149">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-150">
          <p className="text-text-main text-lg sm:text-xl font-bold mb-6" data-id="element-151">
            ✋ ¿Te has reconocido? Entonces este Kit es exactamente para ti.
          </p>
          <a href="#pricing" className="inline-block bg-cta-green text-white font-black text-base sm:text-xl px-8 sm:px-10 py-4 rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-152">
            🚀 QUIERO RECUPERAR MI TIEMPO
          </a>
        </div>
      </div>
    </section>;
}